module.exports = __webpack_public_path__ + "static/media/gift01_zhCht.4ba2de99.png";